import { SWRResponse } from "swr";
import { AppRouteApi } from "../../config/appRoute";
import { ApiSchemaInsuranceType } from "../../models/api/insuranceType";
import { AxiosAuth } from "../axios";
import { ApiResponseContainer } from "../../models/api/responseContainer";
import { InsuranceFormType } from "../../models/forms/insurance";
import {
  CreateAccessObject,
  useExtendedApiAccess,
} from "./useExtendedApiAccess";
const CacheIds = {
  GetInsuranceTypes: AppRouteApi.InsuranceTypes.Root(),
  ById: AppRouteApi.InsuranceTypes.ById(""),
};

function useApiInsuranceTypesGet(): SWRResponse<
  ApiSchemaInsuranceType[] | undefined,
  Error
> {
  return useExtendedApiAccess<ApiSchemaInsuranceType[]>(
    CacheIds.GetInsuranceTypes,
    () => AxiosAuth.get(CacheIds.GetInsuranceTypes)
  );
}
function useApiInsuranceTypesById(
  id: string
): SWRResponse<ApiSchemaInsuranceType | undefined, Error> {
  return useExtendedApiAccess<ApiSchemaInsuranceType>(CacheIds.ById, () =>
    AxiosAuth.get(AppRouteApi.InsuranceTypes.ById(id))
  );
}

const AccessObject = {
  GetInsuranceTypes: CreateAccessObject<
    ApiSchemaInsuranceType[],
    typeof useApiInsuranceTypesGet
  >(CacheIds.GetInsuranceTypes, useApiInsuranceTypesGet),

  ById: CreateAccessObject<
    ApiSchemaInsuranceType,
    typeof useApiInsuranceTypesById
  >(CacheIds.ById, useApiInsuranceTypesById),
};

const AddInsuranceType = async (data: InsuranceFormType) => {
  const res = await AxiosAuth.post<
    ApiResponseContainer<ApiSchemaInsuranceType>
  >(AppRouteApi.InsuranceTypes.Root(), data);
  return res;
};

const UpdateInsuranceType = async (data: ApiSchemaInsuranceType) => {
  const res = await AxiosAuth.put<ApiResponseContainer<ApiSchemaInsuranceType>>(
    AppRouteApi.InsuranceTypes.Root(),
    data
  );
  return res;
};

const DeleteInsuranceType = async (ids: string[]) => {
  const responses = await Promise.all(
    ids.map((id) =>
      AxiosAuth.delete<boolean>(AppRouteApi.InsuranceTypes.Delete(id))
    )
  );

  return ids.filter((id, index) => !!responses[index].data);
};

const ToggleStatus = async (insurance: ApiSchemaInsuranceType) => {
  return await UpdateInsuranceType({
    ...insurance,
    isDisabled: !insurance.isDisabled,
  });
};

export const ApiInsuranceTypes = {
  ById: AccessObject.ById,
  GetInsuranceTypes: AccessObject.GetInsuranceTypes,
  Add: AddInsuranceType,
  Update: UpdateInsuranceType,
  Delete: DeleteInsuranceType,
  ToggleStatus,
};
